"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStandingOrders = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = require("react");
var Sentry = _interopRequireWildcard(require("@sentry/react"));
var _lodash = require("lodash");
var _useCustomerProductLists = require("../../commerce-api/custom/hooks/useCustomerProductLists");
var _StandingOrdersType = require("../../../types/StandingOrdersType");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const PWA_DEFAULT_STANDING_ORDERS_NAME = 'PWA StandingOrders';
const PWA_DEFAULT_STANDING_ORDERS_TYPE = 'custom_1';
const useStandingOrders = () => {
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const cpl = (0, _useCustomerProductLists.useCustomerProductLists)(PWA_DEFAULT_STANDING_ORDERS_NAME, PWA_DEFAULT_STANDING_ORDERS_TYPE);
  const fetchAll = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(function* () {
      setIsLoading(true);
      try {
        yield cpl.init();
      } catch (error) {
        // Render the widget empty instead of leaving a permanent spinner
        // or an unhandled rejection from the mount effect.
        Sentry.captureException(error);
      } finally {
        setIsLoading(false);
      }
    });
    return function fetchAll() {
      return _ref.apply(this, arguments);
    };
  }();
  const pickProps = standingOrder => {
    return standingOrder ? (0, _lodash.pick)(standingOrder, ['id', 'c_orderingPayment', 'c_orderingShippingAddress', 'c_orderingBillingAddress', 'c_orderingInterval', 'c_orderingStartDate', 'c_orderingStatus', 'c_orderingShipping', 'c_orderingDeliveryTable']) : null;
  };
  const parseProps = standingOrder => {
    if (standingOrder) {
      _StandingOrdersType.jsonFields.forEach(f => {
        if (standingOrder[f]) {
          standingOrder[f] = typeof standingOrder[f] === 'object' ? standingOrder[f] : JSON.parse(standingOrder[f]);
        }
      });
      return standingOrder;
    }
  };
  (0, _react.useEffect)(() => {
    fetchAll();
  }, []);
  const self = _objectSpread(_objectSpread({
    isLoading,
    refetch: () => fetchAll()
  }, cpl), {}, {
    get(id) {
      var _cpl$data;
      return parseProps((_cpl$data = cpl.data) === null || _cpl$data === void 0 ? void 0 : _cpl$data[id]);
    },
    getAll() {
      if (cpl.data) {
        var _Object$values$map;
        const orders = (_Object$values$map = Object.values(cpl.data).map(x => x)) === null || _Object$values$map === void 0 ? void 0 : _Object$values$map.filter(list => list.type === PWA_DEFAULT_STANDING_ORDERS_TYPE).map(list => parseProps(list));
        return orders.sort((a, b) => (b === null || b === void 0 ? void 0 : b.c_orderingStatus) - (a === null || a === void 0 ? void 0 : a.c_orderingStatus) || (b === null || b === void 0 ? void 0 : b.creationDate) - (a === null || a === void 0 ? void 0 : a.creationDate));
      }
    },
    update(order) {
      const updatedOrder = pickProps(order);
      if (updatedOrder) {
        cpl.updateList(updatedOrder);
      }
    },
    setOrderStatus(id, status) {
      const standingOrder = self.get(id);
      if (standingOrder) {
        standingOrder.c_orderingStatus = status;
        const updatedOrder = pickProps(standingOrder);
        if (updatedOrder) {
          cpl.updateList(updatedOrder);
        }
      }
    },
    setDeliveryStatus(id, deliveryId, status) {
      const standingOrder = self.get(id);
      if (standingOrder && (0, _StandingOrdersType.isStandingOrderDeliveryTable)(standingOrder.c_orderingDeliveryTable)) {
        standingOrder.c_orderingDeliveryTable.deliveries = standingOrder.c_orderingDeliveryTable.deliveries.map(od => od.id === deliveryId ? _objectSpread(_objectSpread({}, od), {}, {
          status
        }) : od);
        const updatedOrder = pickProps(standingOrder);
        if (updatedOrder) cpl.updateList(updatedOrder);
      }
    },
    suspend(id) {
      self.setOrderStatus(id, 0);
    },
    activate(id) {
      self.setOrderStatus(id, 1);
    },
    suspendDelivery(id, deliveryId) {
      self.setDeliveryStatus(id, deliveryId, 0);
    },
    activateDelivery(id, deliveryId) {
      self.setDeliveryStatus(id, deliveryId, 1);
    },
    skipNext(id) {
      const standingOrder = self.get(id);
      if (standingOrder && (0, _StandingOrdersType.isStandingOrderDeliveryTable)(standingOrder.c_orderingDeliveryTable)) {
        var _standingOrder$c_orde;
        const nextDeliveryDate = new Date(standingOrder.c_orderingNextShippingDate ?? ((_standingOrder$c_orde = standingOrder.c_orderingDeliveryTable.deliveries.sort()[0]) === null || _standingOrder$c_orde === void 0 ? void 0 : _standingOrder$c_orde.shippingDate)).toISOString();
        const nextDelivery = standingOrder.c_orderingDeliveryTable.deliveries.find(od => od.shippingDate === nextDeliveryDate);
        if (nextDelivery) {
          self.setDeliveryStatus(id, nextDelivery.id, 0);
        }
      }
    },
    /**
     * Suspends an order and all its deliveries
     * @param id - The standing order ID
     */
    suspendOrderWithDeliveries(id) {
      const standingOrder = self.get(id);
      if (standingOrder) {
        // Suspend the order
        standingOrder.c_orderingStatus = 0;

        // Suspend all deliveries
        if ((0, _StandingOrdersType.isStandingOrderDeliveryTable)(standingOrder.c_orderingDeliveryTable)) {
          standingOrder.c_orderingDeliveryTable.deliveries = standingOrder.c_orderingDeliveryTable.deliveries.map(delivery => _objectSpread(_objectSpread({}, delivery), {}, {
            status: 0
          }));
        }
        const updatedOrder = pickProps(standingOrder);
        if (updatedOrder) {
          cpl.updateList(updatedOrder);
        }
      } else {
        self.suspend(id);
      }
    },
    /**
     * Reactivates an order and all its deliveries
     * @param id - The standing order ID
     */
    reactivateOrderWithDeliveries(id) {
      const standingOrder = self.get(id);
      if (standingOrder) {
        // Reactivate the order
        standingOrder.c_orderingStatus = 1;

        // Reactivate all deliveries
        if ((0, _StandingOrdersType.isStandingOrderDeliveryTable)(standingOrder.c_orderingDeliveryTable)) {
          standingOrder.c_orderingDeliveryTable.deliveries = standingOrder.c_orderingDeliveryTable.deliveries.map(delivery => _objectSpread(_objectSpread({}, delivery), {}, {
            status: 1
          }));
        }
        const updatedOrder = pickProps(standingOrder);
        if (updatedOrder) {
          cpl.updateList(updatedOrder);
        }
      } else {
        self.activate(id);
      }
    },
    /**
     * Updates an order along with its items asynchronously to avoid update same object together
     * @param order
     * @param productsToUpdate
     * @param productsToRemove
     */
    updateOrderWithItems(order, productsToUpdate, productsToRemove) {
      return (0, _asyncToGenerator2.default)(function* () {
        const updatedOrder = pickProps(order);
        if (updatedOrder) {
          yield cpl.updateList(updatedOrder);
        }
        if (productsToUpdate.length > 0) {
          for (const product of productsToUpdate) {
            yield cpl.updateListItem((updatedOrder === null || updatedOrder === void 0 ? void 0 : updatedOrder.id) || '', {
              id: product.orderItemId,
              quantity: product.quantity
            });
          }
        }
        if (productsToRemove.length > 0) {
          for (const productId of productsToRemove) {
            yield cpl.removeListItem((updatedOrder === null || updatedOrder === void 0 ? void 0 : updatedOrder.id) || '', productId);
          }
        }
      })();
    }
  });
  return self;
};
exports.useStandingOrders = useStandingOrders;